import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center justify-center gap-4 p-12 bg-white border border-gray-200 rounded-xl" };
const _hoisted_2 = { class: "text-lg font-semibold text-gray-900" };
const _hoisted_3 = { class: "max-w-xs text-sm text-center text-gray-500" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChargeEmptyState',
    emits: ["create"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full" }, [
                    _createElementVNode("svg", {
                        class: "w-8 h-8 text-gray-400",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        "stroke-width": "1.5",
                        stroke: "currentColor"
                    }, [
                        _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        })
                    ])
                ], -1)),
                _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("services.charges.empty.title")), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("services.charges.empty.description")), 1),
                _createElementVNode("button", {
                    type: "button",
                    class: "flex items-center gap-2 px-4 py-2 text-sm font-medium text-white transition-colors rounded-lg bg-egreen-500 hover:bg-egreen-600",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('create')))
                }, [
                    _cache[1] || (_cache[1] = _createElementVNode("svg", {
                        class: "w-4 h-4",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        "stroke-width": "2",
                        stroke: "currentColor"
                    }, [
                        _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M12 4.5v15m7.5-7.5h-15"
                        })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("services.charges.actions.create_charge")), 1)
                ])
            ]));
        };
    }
});
